<template>
  <div>
    <div class="increment-service">
      <div class="header-banner">
        <div class="header-overlay">
          <p class="header-overlay_title">增值服务</p>
        </div>
      </div>

      <div class="quick-service">
        <div class="service-header">
          <p>会员增值服务</p>
        </div>
        <div class="service-scroll-container">
          <div class="service-content" v-if="serviceList.length">
            <div
                class="service-content_item"
                v-for="service in serviceList"
                :style="{
                backgroundImage: `url(${imgBasrUrl + service.imageUrl})`,
              }"
                :key="service.id"
                @click.stop.prevent="gotoDetail(service)"
            >
              <div class="finance-content">
                <h2 class="finance-title">{{ service.title }}</h2>
                <p class="finance-description">
                  {{ service.subtitle }}
                </p>
              </div>
            </div>
          </div>
          <!-- <div v-else class="no-data">暂无对应数据</div> -->
        </div>
      </div>
    </div>

    <div class="news-section" v-if="lookNews">
      <!-- 新闻列表 -->
      <div v-if="!showNewsList" class="news-wrapper">
        <template v-if="newsData.length">
          <news-list
            v-for="(item, index) in newsData"
            :key="index"
            :newData="item"
            @lookMore="lookMore"
            @lookMyEyes="lookMyEyes"
          />
        </template>
        <div v-else class="empty-box">
          <el-empty :image="require('@/assets/recycling/index/empty.svg')"></el-empty>
        </div>
      </div>

      <!-- 查看更多列表 -->
      <news-info
        v-else
        :choseNewTypeInfo="choseNewTypeInfo"
        @goBack="goBack"
        @lookMyEyes="lookMyEyes"
      />
    </div>

    <!-- 新闻详情 -->
    <new-content
      v-else
      :newsContentInfo="newsContentInfo"
      @goParent="goParent"
      @goSecond="goSecond"
    />
  </div>
</template>

<script>
import {getServicesEntryList} from '@/API/goverment/goverment.js';
import newsList from '@/views/policyInformation/component/newsList.vue';
import newsInfo from '@/views/marketRiskControl/component/newsInfo.vue';
import newContent from '@/views/marketRiskControl/component/newContent.vue';
import { getPunishmentList } from '@/API/news/news.js';
import { scrollTop } from '@/util/scrollTop';

export default {
  components: { newsList, newsInfo, newContent },
  data() {
    return {
      imgBasrUrl: process.env.VUE_APP_BASE_URL,
      serviceList: [],
      // 新闻状态
      showNewsList: false,
      lookNews: true,
      newsData: [],
      choseNewTypeInfo: {},
      newsContentInfo: '',
    };
  },
  created() {
    getServicesEntryList('valueServicesPage').then((res) => {
      console.log('获取快捷服务入口', res);
      if (res.code == 200 && res.data && res.data.length) {
        if (res.data[0].contents && res.data[0].contents.length) {
          this.serviceList = res.data[0].contents.filter(
              (item) => item.status == 0,
          );
        } else {
          this.serviceList = [];
        }
      } else {
        this.serviceList = [];
        this.$message.error(res.message);
      }
    });
  },
  computed: {},
  mounted() {
    this.getArticleList();
  },
  methods: {
    gotoDetail(data) {
      console.log('99999999999999', data)
      if (data.linkParams && data.linkParams.pagekey) {
        this.$router.push({
          name: 'serviceDetail',
          params: data,
          query: {
            pagekey: data.linkParams.pagekey,
            jumpType: data.extraData.jumpType,
            id: data.id,
          },
        });
      } else {
        this.$message.warning('该服务没有配置详情页面');
      }
    },
    // 获取新闻列表
    getArticleList() {
      getPunishmentList({ type: 'finance' }).then((res) => {
        if (res.code === 200 && res.data && res.data.length) {
          res.data.forEach((item) => {
            if (item.articles && item.articles.length > 10) {
              item.articles.length = 10;
            }
          });
          this.newsData = res.data;
        } else {
          this.newsData = [];
        }
      });
    },
    // 点击新闻标题，查看详情
    lookMyEyes(contentInfo) {
      this.lookNews = false;
      this.newsContentInfo = contentInfo;
      scrollTop();
    },
    // 点击"查看更多"
    lookMore(item) {
      this.choseNewTypeInfo = { name: item.name, id: item.id, description: item.description };
      this.showNewsList = true;
      scrollTop();
    },
    // 从"查看更多"列表返回
    goBack() {
      this.showNewsList = false;
      this.getArticleList();
      scrollTop();
    },
    // 从新闻详情返回首页
    goParent() {
      this.lookNews = true;
      this.showNewsList = false;
      this.getArticleList();
      scrollTop();
    },
    // 从新闻详情返回"查看更多"列表
    goSecond(info) {
      const parentId = info.parentId ? info.parentId[0] : null;
      let category = {};
      if (parentId) {
        category = this.newsData.find((item) => item.id == parentId) || {};
      }
      this.choseNewTypeInfo = {
        id: category.id || this.newsData[0]?.id,
        name: category.name || this.newsData[0]?.name,
      };
      this.showNewsList = true;
      this.lookNews = true;
      scrollTop();
    },
  },
};
</script>

<style scoped lang="less">
.increment-service {
  max-width: 1200px;
  margin: 0 auto 60px;
  font-family: 'Microsoft YaHei', sans-serif;
}

.header-banner {
  background-image: url('../../assets/recycling/componyImages/addedServices.png');
  background-size: cover;
  background-position: center;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 40px;
}

.header-overlay {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
}

.header-overlay_title {
  font-size: 36px;
  color: #fff;
  align-self: flex-start;
  margin-top: 50px;
  margin-left: 50px;
  color: black;
  font-weight: 400;
}

.quick-service {
  margin-top: 30px;
  padding: 0 20px;
}

.service-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.service-header p {
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 0px;
  color: rgba(0, 0, 0, 1);
  margin: 0;
}

.service-content {
  display: flex;
  flex-wrap: wrap;
  gap: 40px 80px;
  padding: 16px 20px;
  flex-wrap: wrap;
  justify-content: center;

  .service-content_item {
    cursor: pointer;
    width: 300px;
    height: 300px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    align-items: flex-end;
    justify-content: start;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
    }

    .finance-content {
      width: 100%;
      height: 35%;
      position: relative;
      z-index: 2;
      padding: 10px 20px;
      background-color: rgba(0, 0, 0, 0.6);
    }

    .finance-title {
      font-size: 24px;
      margin-bottom: 10px;
      font-weight: bold;
      color: #fff;
    }

    .finance-description {
      font-size: 14px;
      line-height: 1.5;
      color: #fff;
    }
  }
}

.no-data {
  text-align: center;
  color: #999;
  font-size: 14px;
  padding: 20px;
  margin: 10px 0;
  background: #f9f9f9;
  border-radius: 4px;
}

@media (max-width: 768px) {
  .increment-service {
    max-width: 100% !important;
  }

  .header-banner {
    height: 120px;
  }

  .service-header p {
    font-size: 18px !important;
  }

  .service-content {
    display: unset !important;
    padding: unset !important;
  }
  .service-content_item {
    width: 100% !important;
    height: 200px !important;
    margin-bottom: 10px !important;
  }
  .finance-content{
    padding: 10px 5px !important;
  }
  .finance-title {
    font-size: 16px !important;
  }

  .finance-description {
    font-size: 14px !important;
  }
}

@media (max-width: 480px) {
  .increment-service {
    max-width: 100% !important;
  }

  .header-overlay_title {
    font-size: 28px;
    margin-bottom: 20px;
  }

  .header-banner {
    height: 120px;
  }

  .service-header p {
    font-size: 18px !important;
  }

  .service-content {
    display: unset !important;
    padding: unset !important;
  }

  .service-content_item {
    width: 100% !important;
    height: 200px !important;
    margin-bottom: 10px !important;
  }
  .finance-content{
    padding: 10px 5px !important;
  }
  .finance-title {
    font-size: 16px !important;
  }

  .finance-description {
    font-size: 14px !important;
  }
}

// 颜色变量
@primary-color: #303133;
@secondary-color: #606266;
@info-color: #909399;
@border-color: #ebeef5;
@shadow-color: rgba(0, 0, 0, 0.1);
@white: #fff;
@error-color: #f56c6c;

// 字体大小
@font-size-base: 14px;
@font-size-large: 16px;
@font-size-title: 22px;
@font-size-header: 18px;

// 间距
@padding-base: 20px;
@padding-small: 15px;
@padding-mini: 10px;
@margin-base: 20px;
@margin-small: 15px;
@margin-large: 25px;

// 圆角
@border-radius-base: 4px;

// 行高
@line-height-base: 1.5;
@line-height-content: 1.8;

// 图片尺寸
@title-image-height: 300px;

/* 新闻内容区样式 */
.news-section {
  width: 1400px;
  margin: 0 auto 50px auto;
  padding-top: 20px;
}

.news-wrapper {
  width: 100%;
}

.empty-box {
  padding: 40px 0;
}

@media (max-width: 768px) {
  .news-section {
    width: 100%;
    padding: 0 10px;
  }
}
</style>
